import { useState, useEffect, useRef } from "react";
import YouTube from "react-youtube";

const YouTubeShorts = ({ videoId }: { videoId: string }) => {
  const [containerWidth, setContainerWidth] = useState(400); // Default width
  const playerRef = useRef<any>(null); // Player instance stored in a ref

  // Update width dynamically based on screen size
  useEffect(() => {
    const updateSize = () => {
        const width =  400; // window.innerWidth < 600 ? window.innerWidth - 20 : 400; // Responsive width
        setContainerWidth(width);
    };
    //console.log("updated size 0",updateSize)
    window.addEventListener("resize", updateSize);
    updateSize(); // Initial call
    //console.log("updated size 1",updateSize)
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  // Cleanup player on unmount
  useEffect(() => {
    return () => {
      if (playerRef.current) {
        try {
          playerRef.current.destroy();
          playerRef.current = null; // Ensure reference is cleared
        } catch (error) {
          console.warn("YouTube player cleanup failed:", error);
        }
      }
    };
  }, []);

  // YouTube Player Options
  const youtubeOpts = { 
     width: containerWidth,
     height: (containerWidth * 16) / 9, // Maintain 9:16 aspect ratio
    playerVars: {
      autoplay: 0,
      controls: 1,
      modestbranding: 1,
      rel: 0,
      showinfo: 0,
      fs: 1,
      hl: "en",
      enablejsapi: 1, // Enable JavaScript API
    },
  };

  // Ensure player is fully loaded before setting HD quality
  const handlePlayerReady = (event: any) => {
    playerRef.current = event.target;

    // Use a try-catch to prevent crashes if API is still initializing
    try {
      setTimeout(() => {
        if (playerRef.current && typeof playerRef.current.setPlaybackQuality === "function") {
          playerRef.current.setPlaybackQuality("720p60");
        }
      }, 1000); // Small delay to ensure readiness
    } catch (error) {
      console.warn("Error setting playback quality:", error);
    }
  };

  return (
    <div className="youtube-shorts-container" style={{ textAlign: "center" }}>
      <YouTube 
        videoId={videoId} 
        className="youtube-video" 
        opts={youtubeOpts}  
        onReady={handlePlayerReady} // Safe initialization
      />
    </div>
  );
};

// Example Usage
export default YouTubeShorts;
